import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CustomPaginationComponent } from './component/custom-pagination.component'
import { PaginationModule } from '@spartacus/storefront'

@NgModule({
  declarations: [CustomPaginationComponent],
  exports: [CustomPaginationComponent],
  imports: [CommonModule, PaginationModule]
})
export class CustomPaginationModule {}
